export enum InvoiceTemplate {
Micronoesis,
CLMSHellas,
CLMSUK,
}
